/**
 * Theme Javascript - Xego x Shapes
 * Manejador de variantes, selector de cantidad, galería y carrito
 */




// Prevenir saltos de scroll involuntarios del navegador al recargar o cargar la página
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
if (!window.location.hash) {
  window.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
      if (window.scrollY > 0) window.scrollTo(0, 0);
    });
  }, { once: true });
}

// ==========================================================================
// 0. HEADER FLOTANTE SCROLL UP (Aparece al subir scroll, se oculta al bajar)
// ==========================================================================
function initScrollUpHeader() {
  const headerWrapper = document.querySelector('[data-scroll-header], .site-header-wrapper');
  if (!headerWrapper) return;

  let lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

        // Comprobar si el usuario está dentro de la sección Hero Scrollytelling
        const scrollyTrack = document.querySelector('.xego-scrolly-track');
        const scrollyCard = document.querySelector('.xego-scrolly-card');
        let isHeroActiveBeforeClosing = false;

        if (scrollyTrack && scrollyCard) {
          const trackRect = scrollyTrack.getBoundingClientRect();
          const isClosing = scrollyCard.classList.contains('is-closing-active');
          // El Hero está en pantalla si su borde superior ya entró y su base aún no ha salido
          const isHeroInView = trackRect.top < window.innerHeight * 0.75 && trackRect.bottom > window.innerHeight * 0.25;
          if (isHeroInView && !isClosing) {
            isHeroActiveBeforeClosing = true;
          }
        }

        if (currentScrollY > 150) {
          if (isHeroActiveBeforeClosing || currentScrollY < lastScrollY) {
            headerWrapper.classList.add('header--sticky');
            headerWrapper.classList.remove('header--hidden');
          } else {
            headerWrapper.classList.add('header--hidden');
          }
        } else {
          // En el top de la página (scroll <= 150), mantener el header en su flujo natural sin cortarse
          headerWrapper.classList.remove('header--sticky', 'header--hidden');
        }
        lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}


// 1. Galería de Producto
function initProductGallery() {
  const mainImage = document.getElementById('ProductMainImage');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');

  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const targetSrc = thumb.dataset.imageSrc;
      if (!targetSrc) return;

      mainImage.src = targetSrc;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}

// 2. Selectores de Cantidad
function initQuantitySelectors() {
  document.querySelectorAll('[data-quantity-wrapper]').forEach(wrapper => {
    const input = wrapper.querySelector('[data-quantity-input]');
    const minusBtn = wrapper.querySelector('[data-quantity-minus]');
    const plusBtn = wrapper.querySelector('[data-quantity-plus]');

    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
}

// 3. Selectores de Variante
function initVariantPickers() {
  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  const variantJsonElement = document.getElementById('ProductVariantsJson');
  if (!variantJsonElement) return;

  let variants = [];
  try {
    variants = JSON.parse(variantJsonElement.textContent);
  } catch (e) {
    console.error('Error al parsear variantes del producto', e);
    return;
  }

  const masterSelect = document.getElementById('ProductSelectMaster');
  const pills = document.querySelectorAll('[data-variant-pill]');

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      const optionIndex = pill.dataset.optionIndex;
      const optionValue = pill.dataset.optionValue;

      // Desmarcar hermanos de la misma opción
      document.querySelectorAll(`[data-variant-pill][data-option-index="${optionIndex}"]`).forEach(sibling => {
        sibling.classList.remove('is-selected');
        sibling.setAttribute('aria-selected', 'false');
      });

      pill.classList.add('is-selected');
      pill.setAttribute('aria-selected', 'true');

      // Buscar combinación seleccionada
      const selectedOptions = Array.from(document.querySelectorAll('[data-variant-pill].is-selected'))
        .map(el => el.dataset.optionValue);

      const matchedVariant = variants.find(variant => {
        return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
      });

      if (matchedVariant) {
        if (masterSelect) masterSelect.value = matchedVariant.id;

        // Actualizar precio
        const priceEl = document.querySelector('[data-product-price]');
        const comparePriceEl = document.querySelector('[data-compare-price]');
        
        if (priceEl && matchedVariant.price) {
          priceEl.innerHTML = formatMoney(matchedVariant.price);
        }
        if (comparePriceEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceEl.innerHTML = formatMoney(matchedVariant.compare_at_price);
            comparePriceEl.style.display = 'inline-block';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        // Actualizar imagen si la variante tiene una asociada (soporte nueva galería multi-slide)
        if (matchedVariant.featured_media && matchedVariant.featured_media.id) {
          const targetThumb = document.querySelector(`[data-gallery-thumb][data-media-id="${matchedVariant.featured_media.id}"]`);
          if (targetThumb) targetThumb.click();
        } else if (matchedVariant.featured_image && matchedVariant.featured_image.id) {
          const targetThumb = document.querySelector(`[data-gallery-thumb][data-media-id="${matchedVariant.featured_image.id}"]`);
          if (targetThumb) targetThumb.click();
        } else if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
          const mainImg = document.getElementById('ProductMainImage');
          if (mainImg) mainImg.src = matchedVariant.featured_image.src;
        }

        // Actualizar botón de compra (preservar texto configurado por el usuario)
        const submitBtn = productForm.querySelector('[type="submit"]');
        if (submitBtn) {
          const titleSpan = submitBtn.querySelector('.btn-cod-title span') || submitBtn;
          if (!submitBtn.dataset.originalText && titleSpan) {
            submitBtn.dataset.originalText = titleSpan.textContent.trim();
          }

          if (matchedVariant.available) {
            submitBtn.removeAttribute('disabled');
            if (titleSpan) {
              titleSpan.textContent = submitBtn.dataset.originalText || 'AGREGAR AL CARRITO';
            }
          } else {
            submitBtn.setAttribute('disabled', 'disabled');
            if (titleSpan) {
              titleSpan.textContent = 'AGOTADO';
            }
          }
        }
      }
    });
  });
}

// 4. Formateo de Moneda simple
function formatMoney(cents) {
  return '$' + (cents / 100).toLocaleString('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

// 5. Manejo del formulario de compra estándar (Agregar al Carrito / Comprar Ahora)
function initCodButtons() {
  const forms = document.querySelectorAll('[data-product-form], #AddToCartForm');
  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      // Si el botón presionado fue 'Comprar Ahora'
      const submitter = e.submitter;
      if (submitter && (submitter.name === 'checkout' || submitter.hasAttribute('data-buy-now-btn'))) {
        e.preventDefault();
        const formData = new FormData(form);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          });
          window.location.href = '/checkout';
        } catch (err) {
          window.location.href = '/checkout';
        }
        return;
      }

      // Si fue 'Agregar al Carrito' normal:
      const action = form.getAttribute('action') || '/cart/add';
      if (action.includes('/cart/add')) {
        e.preventDefault();
        const formData = new FormData(form);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          });
          if (res.ok) {
            if (window.refreshCartDrawer && window.openCartDrawer) {
              await window.refreshCartDrawer();
              window.openCartDrawer();
            } else {
              window.location.href = '/cart';
            }
          }
        } catch (err) {
          console.error('Error al agregar al carrito', err);
        }
      }
    });
  });
}

// 7. Acordeón FAQ con Animación Suave (Web Animations API nativa)
class ThemeAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.body = el.querySelector('.accordion-body') || el.querySelector('.accordion-content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!this.summary || !this.body) return;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 320,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => { this.isClosing = false; };
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.body.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 340,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => { this.isExpanding = false; };
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  }
}

function initAccordionAnimation() {
  document.querySelectorAll('[data-accordion-card]').forEach(el => {
    new ThemeAccordion(el);
  });
}

// 8. Lightbox con Modal Fluido y Navegación Táctil/Teclado
function initLightbox() {
  const modal = document.getElementById('LightboxModal');
  if (!modal) return;

  const activeImg = document.getElementById('LightboxImage');
  const captionEl = document.getElementById('LightboxCaption');
  const prevBtn = modal.querySelector('[data-lightbox-prev]');
  const nextBtn = modal.querySelector('[data-lightbox-next]');
  const closeTriggers = modal.querySelectorAll('[data-lightbox-close]');
  const triggers = Array.from(document.querySelectorAll('[data-lightbox-trigger]'));

  if (triggers.length === 0) return;

  let currentIndex = -1;

  const updateModalContent = (index) => {
    if (index < 0 || index >= triggers.length) return;
    currentIndex = index;
    const trigger = triggers[currentIndex];
    const src = trigger.dataset.lightboxSrc || trigger.querySelector('img')?.src;
    const caption = trigger.dataset.lightboxCaption || '';
    const alt = trigger.querySelector('img')?.alt || 'Foto de cliente';

    if (activeImg) {
      activeImg.src = src;
      activeImg.alt = alt;
    }

    if (captionEl) {
      if (caption.trim().length > 0) {
        captionEl.textContent = caption;
        captionEl.classList.add('has-content');
      } else {
        captionEl.textContent = '';
        captionEl.classList.remove('has-content');
      }
    }
  };

  const openLightbox = (index) => {
    currentIndex = index;
    updateModalContent(currentIndex);
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    if (!modal.classList.contains('is-active')) return;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  triggers.forEach((trigger, idx) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openLightbox(idx);
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(idx);
      }
    });
  });

  closeTriggers.forEach(btn => {
    btn.addEventListener('click', closeLightbox);
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const prevIdx = (currentIndex - 1 + triggers.length) % triggers.length;
      updateModalContent(prevIdx);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const nextIdx = (currentIndex + 1) % triggers.length;
      updateModalContent(nextIdx);
    });
  }

  window.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-active')) return;

    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowLeft' && triggers.length > 1) {
      const prevIdx = (currentIndex - 1 + triggers.length) % triggers.length;
      updateModalContent(prevIdx);
    } else if (e.key === 'ArrowRight' && triggers.length > 1) {
      const nextIdx = (currentIndex + 1) % triggers.length;
      updateModalContent(nextIdx);
    }
  });
}




// ==========================================================================
// 9. CART DRAWER (Slide-out AJAX Cart & Free Shipping Bar)
// ==========================================================================
function getFreeShippingThreshold() {
  const bar = document.getElementById('CartShippingBar');
  if (bar && bar.dataset.threshold) {
    const val = parseFloat(bar.dataset.threshold);
    if (!isNaN(val) && val > 0) return val;
  }
  return 12000000; // $120.000 COP en centavos (120000 * 100)
}

window.openCartDrawer = function() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};

window.closeCartDrawer = function() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

window.refreshCartDrawer = async function() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch (err) {
    console.error('Error al actualizar carrito AJAX', err);
  }
};

function getProductsSubtotal(cart) {
  if (cart.items && cart.items.length > 0) {
    return cart.items.reduce((acc, item) => acc + (item.final_line_price || item.line_price || 0), 0);
  }
  if (cart.items_subtotal_price !== undefined && cart.items_subtotal_price !== null) {
    return cart.items_subtotal_price;
  }
  return cart.total_price || 0;
}

function renderCartDrawer(cart) {
  // 1. Actualizar contadores
  const headerCount = document.getElementById('CartCount');
  const drawerCount = document.getElementById('CartDrawerCount');
  if (headerCount) headerCount.textContent = cart.item_count;
  if (drawerCount) drawerCount.textContent = cart.item_count;

      // 2. Obtener Subtotal Real de Productos (Excluyendo tarifas fijas de envío)
  const productsSubtotal = getProductsSubtotal(cart);

  // 3. Actualizar Barra de Envío Gratis Dinámica basada exclusivamente en productos
  const shippingMsg = document.getElementById('ShippingBarMessage');
  const shippingFill = document.getElementById('ShippingBarFill');
  if (shippingMsg && shippingFill) {
    const threshold = getFreeShippingThreshold();
    if (productsSubtotal >= threshold && cart.item_count > 0) {
      shippingMsg.innerHTML = '🎉 ¡Felicidades! Tienes <strong>Envío Gratis</strong>';
      shippingFill.style.width = '100%';
    } else if (cart.item_count > 0) {
      const remaining = threshold - productsSubtotal;
      const formattedRemaining = formatMoney(remaining);
      const percentage = Math.min(100, Math.max(5, (productsSubtotal / threshold) * 100));
      shippingMsg.innerHTML = `Te faltan <strong>${formattedRemaining}</strong> para <strong>Envío Gratis</strong>`;
      shippingFill.style.width = `${percentage}%`;
    } else {
      const formattedThreshold = formatMoney(threshold);
      shippingMsg.innerHTML = `Envío gratis en compras superiores a <strong>${formattedThreshold}</strong>`;
      shippingFill.style.width = '0%';
    }
  }

  // 4. Subtotal puro de productos y visibilidad del Footer
  const subtotalEl = document.getElementById('CartDrawerSubtotal');
  const footerEl = document.getElementById('CartDrawerFooter');
  const upsellEl = document.getElementById('CartDrawerUpsell');
  if (subtotalEl) subtotalEl.textContent = formatMoney(productsSubtotal);

  // Verificar si "6 pares de medias" ya está en el carrito
  const hasUpsellInCart = cart.items && cart.items.some(item => 
    item.handle === '6-pares-de-medias' || 
    item.product_id === 10999671161116 ||
    (item.product_title && item.product_title.toLowerCase().includes('6 pares de medias')) ||
    (item.title && item.title.toLowerCase().includes('6 pares de medias'))
  );

  if (cart.item_count === 0) {
    if (footerEl) footerEl.style.display = 'none';
    if (upsellEl) {
      upsellEl.style.display = 'none';
      upsellEl.classList.remove('is-added');
    }
  } else {
    if (footerEl) footerEl.style.display = 'block';
    if (upsellEl) {
      upsellEl.style.display = hasUpsellInCart ? 'none' : 'block';
      if (!hasUpsellInCart) {
        upsellEl.classList.remove('is-added');
        const btn = upsellEl.querySelector('[data-add-upsell]');
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading', 'is-success');
          btn.innerHTML = '<span class="cart-upsell-btn-text">+ Añadir</span>';
        }
      }
    }
  }

  // 4. Renderizar Items
  const itemsContainer = document.getElementById('CartDrawerItems');
  if (!itemsContainer) return;

  if (cart.item_count === 0) {
    itemsContainer.innerHTML = `
      <div class="cart-drawer__empty" id="CartDrawerEmpty">
        <div class="empty-cart-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
        </div>
        <h4>Tu carrito está vacío</h4>
        <p>Descubre nuestros productos y disfruta de ofertas exclusivas hoy.</p>
        <button type="button" class="btn-primary" data-cart-drawer-close style="margin-top: 1rem; padding: 0.8rem 1.5rem; background: var(--color-primary); color: #fff; border: 2px solid #000; border-radius: var(--radius-md); font-family: var(--font-heading); font-weight: 800; cursor: pointer;">
          EXPLORAR PRODUCTOS
        </button>
      </div>
    `;
    const emptyBtn = itemsContainer.querySelector('[data-cart-drawer-close]');
    if (emptyBtn) emptyBtn.addEventListener('click', window.closeCartDrawer);
    return;
  }

  let html = '';
  cart.items.forEach(item => {
    const variantTitle = item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : '';
    const comparePrice = (item.original_line_price && item.original_line_price > item.final_line_price) ? `<s class="cart-item__compare-price">${formatMoney(item.original_line_price)}</s>` : '';
    const imgSrc = item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : (item.featured_image.url || '')) : '');
    const title = item.product_title || item.title || 'Producto';

    html += `
      <div class="cart-item" data-line-item-key="${item.key}">
        <div class="cart-item__image-box">
          ${imgSrc ? `<img src="${imgSrc}" alt="${title}" width="80" height="100" loading="lazy">` : ''}
        </div>
        <div class="cart-item__details">
          <div class="cart-item__header">
            <h4 class="cart-item__title"><a href="${item.url || '#' }">${title}</a></h4>
            <button type="button" class="cart-item__remove-btn" data-cart-item-remove="${item.key}" aria-label="Eliminar producto">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
          ${variantTitle}
          <div class="cart-item__price-qty">
            <div class="cart-item__quantity-box">
              <button type="button" class="cart-item__qty-btn" data-qty-change="-1" data-key="${item.key}" data-current="${item.quantity}" aria-label="Restar">-</button>
              <span class="cart-item__qty-value">${item.quantity}</span>
              <button type="button" class="cart-item__qty-btn" data-qty-change="1" data-key="${item.key}" data-current="${item.quantity}" aria-label="Sumar">+</button>
            </div>
            <div class="cart-item__price">
              ${comparePrice}
              <span class="cart-item__final-price">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  });

  itemsContainer.innerHTML = html;
  bindCartItemListeners();
}


// ==========================================================================
// 10. INICIALIZADOR DEL CART DRAWER
// ==========================================================================
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // Delegar apertura y cierre globalmente
  document.addEventListener('click', (e) => {
    // Abrir drawer (si no estamos ya en la página /cart, o si el elemento tiene data-cart-drawer-trigger explícito)
    const isCartPage = window.location.pathname.endsWith('/cart') || window.location.pathname.endsWith('/cart/');
    const trigger = e.target.closest('[data-cart-drawer-trigger], a[href="/cart"], .cart-icon-btn');
    if (trigger) {
      if (isCartPage && !trigger.hasAttribute('data-cart-drawer-trigger')) {
        return;
      }
      e.preventDefault();
      window.openCartDrawer();
      window.refreshCartDrawer();
      return;
    }

    // Cerrar drawer
    const closeBtn = e.target.closest('[data-cart-drawer-close], .cart-drawer__close-btn, .cart-drawer__backdrop');
    if (closeBtn) {
      e.preventDefault();
      window.closeCartDrawer();
      return;
    }
  });

  // Cerrar con Escape
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      window.closeCartDrawer();
    }
  });

  // Inicializar listeners delegados en items
  bindCartItemListeners();

  // Calcular barra de envío gratis inicial
  window.refreshCartDrawer();
}

function bindCartItemListeners() {
  const drawerBody = document.getElementById('CartDrawerBody');
  if (!drawerBody || drawerBody._hasCartListener) return;
  drawerBody._hasCartListener = true;

  drawerBody.addEventListener('click', async (e) => {
    // A. Botones de cantidad (+ o -)
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = qtyBtn.dataset.key;
      const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      const qtyBox = qtyBtn.closest('.cart-item__price-qty') || qtyBtn.parentElement;
      const qtyValEl = qtyBox ? qtyBox.querySelector('.cart-item__qty-value') : null;
      const current = qtyValEl ? parseInt(qtyValEl.textContent.trim(), 10) : 1;
      const newQty = Math.max(0, current + delta);

      qtyBtn.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        if (res.ok) {
          const cart = await res.json();
          renderCartDrawer(cart);
        }
      } catch (err) {
        console.error('Error al cambiar cantidad', err);
      } finally {
        qtyBtn.disabled = false;
      }
      return;
    }

    // B. Botón de eliminar
    const removeBtn = e.target.closest('[data-cart-item-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = removeBtn.dataset.cartItemRemove;
      removeBtn.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (res.ok) {
          const cart = await res.json();
          renderCartDrawer(cart);
        }
      } catch (err) {
        console.error('Error al eliminar item', err);
      }
      return;
    }

    // C. Botón de agregar producto sugerido (Upsell: 6 pares de medias)
    const upsellBtn = e.target.closest('[data-add-upsell]');
    if (upsellBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = upsellBtn.dataset.variantId || '54663445479708';
      const upsellCard = upsellBtn.closest('.cart-drawer__upsell');
      const originalHtml = upsellBtn.innerHTML;

      upsellBtn.disabled = true;
      upsellBtn.classList.add('is-loading');
      upsellBtn.innerHTML = '<span class="upsell-btn-spinner" aria-hidden="true"></span><span>Añadiendo...</span>';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          upsellBtn.classList.remove('is-loading');
          upsellBtn.classList.add('is-success');
          upsellBtn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" style="display:inline-block;vertical-align:middle;margin-right:4px;"><polyline points="20 6 9 17 4 12"/></svg><span>¡Listo!</span>';

          if (upsellCard) {
            upsellCard.classList.add('is-added');
            await new Promise(resolve => setTimeout(resolve, 420));
          }
          await window.refreshCartDrawer();
          upsellBtn.disabled = false;
          upsellBtn.classList.remove('is-loading', 'is-success');
          upsellBtn.innerHTML = originalHtml;
        } else {
          throw new Error('Error en respuesta de carrito');
        }
      } catch (err) {
        console.error('Error al agregar producto sugerido', err);
        upsellBtn.disabled = false;
        upsellBtn.classList.remove('is-loading', 'is-success');
        upsellBtn.innerHTML = originalHtml;
      }
      return;
    }
  });
}

// ==========================================================================
// 11. CAROUSELS & QUICK ADD (Products & Reviews Touch Scroll / Buttons)
// ==========================================================================
function initProductsCarousel() {
  const carousels = document.querySelectorAll('[data-products-carousel], [data-reviews-carousel]');
  carousels.forEach(carousel => {
    const parentSection = carousel.closest('section') || carousel.parentElement;
    const prevBtn = parentSection.querySelector('[data-carousel-prev]');
    const nextBtn = parentSection.querySelector('[data-carousel-next]');

    const navBtns = parentSection.querySelector('.products-carousel__nav-btns, .reviews-carousel__nav-btns');

    let navTicking = false;
    const updateNavVisibility = () => {
      if (navTicking) return;
      navTicking = true;
      requestAnimationFrame(() => {
        const hasOverflow = carousel.scrollWidth > (carousel.clientWidth + 5);
        if (navBtns) {
          if (!hasOverflow) {
            navBtns.classList.add('is-hidden-no-scroll');
          } else {
            navBtns.classList.remove('is-hidden-no-scroll');
          }
        }

        if (prevBtn) {
          prevBtn.style.opacity = carousel.scrollLeft <= 4 ? '0.35' : '1';
          prevBtn.style.pointerEvents = carousel.scrollLeft <= 4 ? 'none' : 'auto';
        }
        if (nextBtn) {
          const maxScroll = carousel.scrollWidth - carousel.clientWidth - 4;
          nextBtn.style.opacity = carousel.scrollLeft >= maxScroll ? '0.35' : '1';
          nextBtn.style.pointerEvents = carousel.scrollLeft >= maxScroll ? 'none' : 'auto';
        }
        navTicking = false;
      });
    };

    const getScrollStep = () => {
      const firstChild = carousel.firstElementChild;
      if (firstChild) {
        return firstChild.getBoundingClientRect().width + 20;
      }
      return 300;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    carousel.addEventListener('scroll', updateNavVisibility, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(updateNavVisibility).observe(carousel);
    } else {
      window.addEventListener('resize', updateNavVisibility, { passive: true });
    }

    setTimeout(updateNavVisibility, 150);
  });

  // Botones Quick Add en tarjetas de producto
  document.querySelectorAll('[data-quick-add-btn]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          await window.refreshCartDrawer();
          window.openCartDrawer();
        }
      } catch (err) {
        console.error('Error en quick add', err);
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });
}

// ==========================================================================
// 12. RELEASIT EFFECTS & NATIVE BUTTON HIDING OBSERVER
// ==========================================================================
function initReleasitEffects() {
  function checkAndHideNativeButtons() {
    document.querySelectorAll('.product-cta-group, .xego-scrolly__product-form, .product-form__buttons').forEach(group => {
      const releasitTrigger = group.querySelector('.rsi-button, .rsi-btn, #releasit-button, .releasit-cod-btn, .rsi-form-content-wrapper');
      if (releasitTrigger) {
        const nativeButtons = group.querySelectorAll('.product-form__submit, .btn-cod');
        nativeButtons.forEach(btn => {
          if (!btn.matches('.rsi-button, .rsi-btn, #releasit-button, .releasit-cod-btn')) {
            btn.style.setProperty('display', 'none', 'important');
          }
        });
      }
    });
  }

  // Ejecución inicial
  checkAndHideNativeButtons();

  // Observador de mutaciones para atrapar inyecciones asíncronas de Releasit
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && (node.matches('.rsi-button, .rsi-btn, #releasit-button, .releasit-cod-btn, .rsi-form-content-wrapper') ||
                node.querySelector('.rsi-button, .rsi-btn, #releasit-button, .releasit-cod-btn, .rsi-form-content-wrapper'))) {
              shouldCheck = true;
            }
            // Inyectar textura Noise en modal Releasit si corresponde
            if (node.classList && node.classList.contains('rsi-form-content-wrapper')) {
              if (!node.querySelector('.noise-overlay')) {
                const noise = document.createElement('div');
                noise.className = 'noise-overlay';
                node.prepend(noise);
              }
            }
          }
        });
      });
      if (shouldCheck) {
        checkAndHideNativeButtons();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

// ==========================================================================
// STICKY ADD TO CART (Barra Flotante Fija de Conversión en Scroll)
// ==========================================================================
function initStickyAddToCart() {
  const stickyBar = document.getElementById('StickyAddToCart');
  if (!stickyBar) return;

  const mainForm = document.querySelector('[data-product-form]') || document.querySelector('.product-form');
  const mainBtn = document.querySelector('[data-add-to-cart-btn]') || document.querySelector('.btn-cod');
  
  if (!mainBtn) return;

  const stickyBtn = document.getElementById('StickySubmitBtn');
  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const stickySelect = document.getElementById('StickyVariantSelect');
      const masterSelect = document.getElementById('ProductSelectMaster');
      if (stickySelect && masterSelect) {
        masterSelect.value = stickySelect.value;
      }
      
      if (mainBtn) {
        mainBtn.click();
      } else {
        mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  // Sincronizar cambios de selector de variante del sticky con el principal
  const stickySelect = document.getElementById('StickyVariantSelect');
  if (stickySelect) {
    stickySelect.addEventListener('change', () => {
      const masterSelect = document.getElementById('ProductSelectMaster');
      if (masterSelect) {
        masterSelect.value = stickySelect.value;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Activar visibilidad con IntersectionObserver cuando el botón de compra principal sale del viewport
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(mainBtn);
  } else {
    window.addEventListener('scroll', () => {
      const rect = mainBtn.getBoundingClientRect();
      if (rect.top < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }, { passive: true });
  }
}

// ==========================================================================
// INICIALIZACIÓN GLOBAL SEGURA (A prueba de fallos individuales)
// ==========================================================================
function initTheme() {
  const modules = [
    ['ScrollUpHeader', typeof initScrollUpHeader === 'function' ? initScrollUpHeader : null],
    ['ProductGallery', typeof initProductGallery === 'function' ? initProductGallery : null],
    ['QuantitySelectors', typeof initQuantitySelectors === 'function' ? initQuantitySelectors : null],
    ['VariantPickers', typeof initVariantPickers === 'function' ? initVariantPickers : null],
    ['CodButtons', typeof initCodButtons === 'function' ? initCodButtons : null],
    ['AccordionAnimation', typeof initAccordionAnimation === 'function' ? initAccordionAnimation : null],
    ['Lightbox', typeof initLightbox === 'function' ? initLightbox : null],
    ['CartDrawer', typeof initCartDrawer === 'function' ? initCartDrawer : null],
    ['StickyAddToCart', typeof initStickyAddToCart === 'function' ? initStickyAddToCart : null],
    ['ProductsCarousel', typeof initProductsCarousel === 'function' ? initProductsCarousel : null],
    ['ReleasitEffects', typeof initReleasitEffects === 'function' ? initReleasitEffects : null]
  ];

  modules.forEach(([name, fn]) => {
    if (fn) {
      try {
        fn();
      } catch (e) {
        console.warn(`[Xego Theme] Advertencia en módulo ${name}:`, e);
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  initTheme();
}
